"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useSplitAnchorPriceStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = {
        padding: '0',
        width: '100%',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };
    const priceStyle = (label) => {
        return {
            fontWeight: '500',
            fontSize: label === 'yourShare' || label === 'total' || label === 'fullyPaid' ? '1rem' : '0.875rem',
            color: label === 'yourShare'
                ? theme.qlub.palette.onSurfaceColors.highEmphasis
                : label === 'fullyPaid'
                    ? theme.qlub.palette.success.main
                    : label === 'total'
                        ? theme.qlub.palette.onSurfaceColors.highEmphasis
                        : label === 'total'
                            ? theme.qlub.palette.onSurfaceColors.mediumEmphasis
                            : label === 'total'
                                ? theme.qlub.palette.onSurfaceColors.disabled
                                : label === 'leftToPay'
                                    ? theme.qlub.palette.onSurfaceColors.mediumEmphasis
                                    : theme.qlub.palette.onSurfaceColors.mediumEmphasis,
            position: 'relative',
            padding: '4px 0',
            '&>span': {
                position: 'absolute',
                insetInlineEnd: '0',
            },
        };
    };
    const taxStyle = {
        padding: '0',
        width: '100%',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };
    return {
        container,
        priceStyle,
        taxStyle,
    };
};
exports.default = useSplitAnchorPriceStyle;
